import { render, staticRenderFns } from "./ShippingChargesFileMovingTaskComponent.vue?vue&type=template&id=469d8ebe&"
import script from "./ShippingChargesFileMovingTaskComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingChargesFileMovingTaskComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports